import React from "react";

const ProjectCard = ({ title, description, tech, codeUrl, liveUrl }) => {
  const handleMouseEnter = (e) => {
    e.currentTarget.style.transform = "translateY(-6px) scale(1.03)";
    e.currentTarget.style.boxShadow = "0 12px 28px rgba(0, 123, 255, 0.6)";
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.transform = "translateY(0) scale(1)";
    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
  };

  return (
    <article
      className="achievement-card"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ cursor: "default" }}
    >
      <div className="achievement-content">
        <h2 className="achievement-title">{title}</h2>
        <p className="achievement-meta text-warning">
          {Array.isArray(tech) ? tech.join(", ") : tech}
        </p>
        <p className="achievement-description">{description}</p>
        <div style={{ marginTop: "auto" }}>
          {/* {codeUrl && (
            <a
              href={codeUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-info me-3"
              style={{ fontWeight: "600" }}
            >
              View Code
            </a>
          )} */}
          {liveUrl && (
            <a
              href={liveUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-info"
              style={{ fontWeight: "600" }}
            >
              Live Demo
            </a>
          )}
        </div>
      </div>
    </article>
  );
};

export default ProjectCard;
